import React from 'react';

function ScaleInput({ options, value, onChange, valueDescriptions }) {
  const currentDesc = value && valueDescriptions ? valueDescriptions[value] : null;

  return (
    <div className="scale">
      <div className="scale__track">
        <div
          className="scale__fill"
          style={{
            width: value
              ? `${((options.findIndex((o) => o.code === value)) / Math.max(options.length - 1, 1)) * 100}%`
              : '0%',
          }}
        />
      </div>
      <div className="scale__points">
        {options.map((option, i) => {
          const selected = value === option.code;
          const filled = value && options.findIndex((o) => o.code === value) >= i;
          return (
            <button
              key={option.code}
              type="button"
              className={
                'scale__point' +
                (selected ? ' scale__point--selected' : '') +
                (filled ? ' scale__point--filled' : '')
              }
              onClick={() => onChange(option.code)}
            >
              <span className="scale__dot" />
              <span className="scale__value">{option.label}</span>
            </button>
          );
        })}
      </div>
      {currentDesc && (
        <div className="scale__description">
          {currentDesc}
        </div>
      )}
    </div>
  );
}

export default ScaleInput;
